import { AbilityBuilder } from '@casl/ability';

import { AppAbility, Role } from './define-permissions';

export const tenantContextPermissions = (
  builder: AbilityBuilder<AppAbility>,
  role: Role,
  userId: string,
  isSSO: boolean,
) => {
  const { can } = builder;

  can('read', 'Administrators');

  can('read', 'Visitors');

  can('read', 'Hosts');

  can('read', 'BillingGroups');

  can('read', 'DestinationsGroups');

  can('read', 'Destinations');

  can('read', 'AccessControlEvents');

  can('read', 'AccessControlProfiles');

  can('read', 'GDPR');

  can('read', 'DefaultSettings');

  can('read', 'OrganizationLogo');

  if (role === 'admin' || role === 'owner' || role === 'master') {
    can('create', 'Visitors');
    can('update', 'Visitors');
    can('delete', 'Visitors');
    can('downloadDiscountTicketsRaport', 'Visitors');
    can('applyDiscount', 'Visitors');
    can('extendVisit', 'Visitors');

    can('allowedInviteToParking', 'Hosts');
    can('manageDiscount', 'Hosts');
    can('manageParkingDiscounts', 'BillingGroups');
    can('manageGroupDestinations', 'DestinationsGroups');

    if (!isSSO) {
      can('create', 'Hosts');
      can('update', 'Hosts');
      can('delete', 'Hosts');
      can('manageDestinations', 'Hosts');
      can('manageDestinationGroup', 'Hosts');
      can('manageBillingGroup', 'Hosts');
      can('create', 'BillingGroups');
      can('update', 'BillingGroups');
      can('delete', 'BillingGroups');

      can('create', 'DestinationsGroups');
      can('update', 'DestinationsGroups');
      can('delete', 'DestinationsGroups');
      can('manageDefaultGroup', 'DestinationsGroups');
    }

    can('create', 'Destinations');
    can('update', 'Destinations');
    can('delete', 'Destinations');
    can('manageAccessControlProfiles', 'Destinations');

    can('create', 'AccessControlEvents');
    can('update', 'AccessControlEvents');
    can('delete', 'AccessControlEvents');

    can('create', 'AccessControlProfiles');
    can('update', 'AccessControlProfiles');
    can('delete', 'AccessControlProfiles');

    can('create', 'GDPR');
    can('update', 'GDPR');
    can('delete', 'GDPR');

    can('create', 'DefaultSettings');
    can('update', 'DefaultSettings');
    can('delete', 'DefaultSettings');

    can('create', 'OrganizationLogo');
    can('update', 'OrganizationLogo');
    can('delete', 'OrganizationLogo');
  }

  if (!isSSO && (role === 'owner' || role === 'master')) {
    can('create', 'Administrators');
    can('update', 'Administrators');

    can('delete', 'Administrators', {
      userId: { $ne: userId },
    });
  }
};
